import { render, staticRenderFns } from "./DrugSafeUserFormFields.vue?vue&type=template&id=d980491c"
import script from "./DrugSafeUserFormFields.vue?vue&type=script&lang=js"
export * from "./DrugSafeUserFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports